<div class="grid">
  <div class="col-8">
    <ng-container *ngIf="selectedConfiguration">
      <p-card>
        <ng-template pTemplate="header">
          <div class="text-lg font-bold p-3">Anteprima email</div>
        </ng-template>
        <div class="border-bottom-1 border-100 py-2">
          <div class="flex justify-content-between align-items-center">
            <span>A</span>
            <p-button
              type="button"
              styleClass="butt"
              [rounded]="true"
              icon="pi pi-plus"
              pTooltip="Aggiungi destinatario"
              (click)="showAddContact('to')"></p-button>
          </div>
          <p-dataView
            #dv
            layout="grid"
            [value]="selectedConfiguration!.to[0].to">
            <ng-template pTemplate="empty"></ng-template>
            <ng-template
              let-contact
              let-index="rowIndex"
              pTemplate="gridItem">
              <p-chip styleClass="mx-2 my-1" [removable]="true" (onRemove)="removeInheritedContact('to', index)">
                <ng-container *ngIf="contact.name || contact.last_name">
                  {{ contact.name }} {{ contact.last_name }} -
                  {{ contact.related_registry?.name }} ({{ contact.email }})
                </ng-container>
                <ng-container *ngIf="!contact.name && !contact.last_name">
                  {{ contact.email }}
                </ng-container>
              </p-chip>
            </ng-template>
          </p-dataView>
          <p-dataView
            #dv
            layout="grid"
            [value]="to.value">
            <ng-template pTemplate="empty"></ng-template>
            <ng-template
              let-contact
              let-index="rowIndex"
              pTemplate="gridItem">
              <p-chip
                styleClass="mx-2 my-1"
                [removable]="true"
                (onRemove)="to.removeAt(index)">
                {{ contact.name }} {{ contact.last_name }} ({{ contact.email }})
              </p-chip>
            </ng-template>
          </p-dataView>
        </div>
        <div class="border-bottom-1 border-100 mt-2 py-2">
          <div class="flex justify-content-between align-items-center">
            <span>CC</span>
            <p-button
              type="button"
              styleClass="butt"
              [rounded]="true"
              icon="pi pi-plus"
              pTooltip="Aggiungi destinatario"
              (click)="showAddContact('cc')"></p-button>
          </div>
          <p-dataView
            #dv
            layout="grid"
            [value]="selectedConfiguration!.to[0].cc">
            <ng-template pTemplate="empty"></ng-template>
            <ng-template
              let-contact
              let-index="rowIndex"
              pTemplate="gridItem">
              <p-chip styleClass="mx-2 my-1" [removable]="true" (onRemove)="removeInheritedContact('cc', index)">
                <ng-container *ngIf="contact.name || contact.last_name">
                  {{ contact.name }} {{ contact.last_name }} -
                  {{ contact.related_registry?.name }} ({{ contact.email }})
                </ng-container>
                <ng-container *ngIf="!contact.name && !contact.last_name">
                  {{ contact.email }}
                </ng-container>
              </p-chip>
            </ng-template>
          </p-dataView>

          <p-dataView
            #dv
            layout="grid"
            [value]="cc.value">
            <ng-template pTemplate="empty"></ng-template>
            <ng-template
              let-contact
              let-index="rowIndex"
              pTemplate="gridItem">
              <p-chip
                styleClass="mx-2 my-1"
                [removable]="true"
                (onRemove)="cc.removeAt(index)">
                {{ contact.name }} {{ contact.last_name }} ({{ contact.email }})
              </p-chip>
            </ng-template>
          </p-dataView>
        </div>
        <div class="border-bottom-1 border-100 mt-2 py-2">
          <div class="flex justify-content-between align-items-center">
            <span>BCC</span>
            <p-button
              type="button"
              styleClass="butt"
              [rounded]="true"
              icon="pi pi-plus"
              pTooltip="Aggiungi destinatario"
              (click)="showAddContact('bcc')"></p-button>
          </div>
          <p-dataView
            #dv
            layout="grid"
            [value]="selectedConfiguration!.to[0].bcc">
            <ng-template pTemplate="empty"></ng-template>
            <ng-template
              let-contact
              let-index="rowIndex"
              pTemplate="gridItem">
              <p-chip styleClass="mx-2 my-1" [removable]="true" (onRemove)="removeInheritedContact('bcc', index)">
                <ng-container *ngIf="contact.name || contact.last_name">
                  {{ contact.name }} {{ contact.last_name }} -
                  {{ contact.related_registry?.name }} ({{ contact.email }})
                </ng-container>
                <ng-container *ngIf="!contact.name && !contact.last_name">
                  {{ contact.email }}
                </ng-container>
              </p-chip>
            </ng-template>
          </p-dataView>

          <p-dataView
            #dv
            layout="grid"
            [value]="bcc.value">
            <ng-template pTemplate="empty"></ng-template>
            <ng-template
              let-contact
              let-index="rowIndex"
              pTemplate="gridItem">
              <p-chip
                styleClass="mx-2 my-1"
                [removable]="true"
                (onRemove)="bcc.removeAt(index)">
                {{ contact.name }} {{ contact.last_name }} ({{ contact.email }})
              </p-chip>
            </ng-template>
          </p-dataView>
        </div>
        <div class="mt-2">
          <div>
            Oggetto
            <br />
            <strong class="text-lg">{{ selectedConfiguration.subject }}</strong>
          </div>
          <div
            class="mt-2 border-1 border-500 p-2 body"
            [innerHTML]="selectedConfiguration.body"></div>
          <ng-container *ngIf="selectedConfiguration.attachments.length > 0 && type === 'schedule'">
            <div class="mt-1">
              <p-button
                (click)="generateReportPDFromTicket()"
                [text]="true"
                icon="pi pi-paperclip"
                label="Ticket"></p-button>
            </div>
          </ng-container>
        </div>

        <ng-template pTemplate="footer">
          <div class="flex flex-row justify-content-end">
            <p-button
              label="Invia"
              [loading]="loading"
              [disabled]="(selectedConfiguration?.to?.[0]?.to?.length || 0) + to.length === 0"
              (click)="sendEmail()"
              icon="pi pi-send"></p-button>
          </div>
        </ng-template>
      </p-card>
    </ng-container>
  </div>

  <div class="profile-container col-4">
    <div class="dettaglio col-12 mb-3 flex flex-column">
      <ng-container [ngSwitch]="type">
        <ng-container *ngSwitchCase="'schedule'">
          <h4>Dettaglio schedulazione</h4>
          <div class="mb-2">
            <label>Data creazione</label><br /><br />
            {{ schedule?.created_on | date: 'dd/MM/yyyy HH:mm' }}
          </div>
          <div class="mb-2">
            <label>Data assegnazione</label><br /><br />
            {{ schedule?.assignment_date | date: 'dd/MM/yyyy HH:mm' }}
          </div>
          <div class="mb-2">
            <label>Data intervento</label><br /><br />
            {{ schedule?.intervention_request_date | date: 'dd/MM/yyyy HH:mm' }}
          </div>
          <div class="mb-2">
            <label>Azienda</label><br /><br />
            {{ schedule?.related_registry?.name }}
          </div>
          <div class="mb-2">
            <label>Assegnatario</label><br /><br />
            {{ schedule?.assigned_user?.name }} {{ schedule?.assigned_user?.last_name }}
          </div>
          <div class="mb-2">
            <label>Durata (ore)</label><br /><br />
            {{ schedule?.duration }}
          </div>
          <div class="mb-2">
            <label>Stato</label><br /><br />
            {{ schedule?.related_schedule_status?.label }}
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'warehouse_load'">
          <h2 class="col-12 text-left">Dettagli movimento di carico</h2>
          <div class="col md:col-6">
            <h3>Codice di riferimento:</h3>
            <span>{{ movement?.identifier }}</span>
          </div>

          <div class="col md:col-6">
            <h3>Tipo di movimento:</h3>
            <span>{{ movement?.movement_type?.name }}</span>
          </div>

          <div
            class="col md:col-6"
            *ngIf="movement?.from_registry_office">
            <h3>Magazzino:</h3>
            <span>{{ movement?.from_registry_office?.name }}</span>
          </div>

          <div class="col md:col-6">
            <h3>Magazzino di destinazione:</h3>
            <span>{{ movement?.to_registry_office?.name }}</span>
          </div>

          <div class="col md:col-6">
            <h3>Data:</h3>
            <span>{{ movement?.created_on | date: 'dd/MM/yyyy,HH:mm' : 'UTC' }}</span>
          </div>

          <div
            class="col md:col-12"
            *ngIf="movement?.notes">
            <h3>Note:</h3>
            <span>{{ movement?.notes }}</span>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'ticket'">
          <h4>Dettaglio ticket</h4>
          <div class="mb-2">
            <label>Numero</label><br /><br />
            {{ ticket?.ticket_number }}.{{ ticket?.ticket_subnumber }}
          </div>
          <div class="mb-2">
            <label>Commessa</label><br /><br />
            {{ ticket?.related_agreement?.name }}
          </div>
          <div class="mb-2">
            <label>Stato</label><br /><br />
            {{ ticket?.ticket_status?.description }}
          </div>
          <div class="mb-2">
            <label>Cliente finale</label><br /><br />
            {{ ticket?.related_registry_end_customer?.name }}
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'delivery'">
          <h4>Dettaglio consegna</h4>
          <div class="mb-2">
            <label>ID</label><br /><br />
            {{ delivery?.id }}
          </div>
          <div class="mb-2">
            <label>Commessa</label><br /><br />
            {{ delivery?.agreement?.name }}
          </div>
          <div class="mb-2">
            <label>Stato</label><br /><br />
            {{ delivery?.delivery_status?.description }}
          </div>
          <div class="mb-2">
            <label>Cliente finale</label><br /><br />
            {{ delivery?.registry_end_customer?.name }}
          </div>
          <div class="mb-2">
            <label>Data consegna</label><br /><br />
            {{ delivery?.delivery_date | date: 'dd/MM/yyyy' }}
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'agreement'">
          <h4>Dettaglio commessa</h4>
          <div class="mb-2">
            <label>Nome</label><br /><br />
            {{ agreementDetail?.name || '-' }}
          </div>
          <div class="mb-2">
            <label>Codice</label><br /><br />
            {{ agreementDetail?.identifier || '-' }}
          </div>
          <div class="mb-2">
            <label>Tipo</label><br /><br />
            {{ agreementDetail?.agreement_type?.name || '-' }}
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'customer_order'">
          <h2 class="col-12 text-left">Dettagli ordine cliente</h2>
          <div class="mb-3">
            <h3>Codice identificativo</h3>
            <span>{{ orderCustomer?.identifier }}</span>
          </div>
          <div class="mb-3">
            <h3>Cliente finale:</h3>
            <span>{{ orderCustomer?.customer_related_registry?.name }}</span>
          </div>
          <div class="mb-3">
            <h3>Cliente per fatturazione:</h3>
            <span> {{ orderCustomer?.billing_related_registry?.name }}</span>
          </div>
          <div class="mb-3">
            <h3>Commessa:</h3>
            <span
              >{{ orderCustomer?.related_agreement?.name }} ({{
                orderCustomer?.related_agreement?.identifier
              }})</span
            >
          </div>
          <div class="mb-3">
            <h3>Workflow:</h3>
            <span>{{ orderCustomer?.related_status_workflow?.name || '-' }}</span>
          </div>
          <div class="mb-3">
            <h3>Cig:</h3>
            <span>{{ orderCustomer?.cig || '-' }}</span>
          </div>
          <div class="mb-3">
            <h3>Cup:</h3>
            <span>{{ orderCustomer?.cup || '-' }}</span>
          </div>
          <div class="mb-3">
            <h3>Num.Ordine cliente:</h3>
            <span>{{ orderCustomer?.external_ref || '-' }}</span>
          </div>
          <div class="mb-3">
            <h3>Codice commessa :</h3>
            <span>{{ orderCustomer?.identifier || '-' }}</span>
          </div>
          <div class="mb-3">
            <h3>Protocollo:</h3>
            <span>{{ orderCustomer?.protocol || '-' }}</span>
          </div>
          <div class="mb-3">
            <h3>Data:</h3>
            <span>{{ orderCustomer?.created_on | date: 'dd/MM/yyyy HH:mm' }}</span>
          </div>
          <div class="mb-3">
            <h3>Data fine evasione:</h3>
            <span>
              {{
                orderCustomer?.fulfillment_date
                  ? (orderCustomer!.fulfillment_date | date: 'dd/MM/yyyy')
                  : '-'
              }}
            </span>
          </div>
          <div class="mb-3">
            <h3>Stato:</h3>
            <span>{{ orderCustomer?.related_status?.label }}</span>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showAddContactForm"
  header="Aggiungi destinatario"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [dismissableMask]="false"
  [closable]="false"
  [style]="{ width: '40vw' }">
  <form
    [formGroup]="addContactForm"
    (ngSubmit)="addContact()">
    <div class="formgrid grid border">
      <div class="field col-12">
        <label for="name">Nome</label>
        <input
          pInput
          formControlName="name"
          id="name"
          type="text"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full" />
      </div>
      <div class="field col-12">
        <label for="last_name">Cognome</label>
        <input
          pInput
          formControlName="last_name"
          id="last_name"
          type="text"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full" />
      </div>
      <div class="field col-12">
        <label for="email">Email<sup>*</sup></label>
        <input
          pInput
          formControlName="email"
          id="email"
          type="email"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full" />
      </div>
      <div class="field col-12 flex flex-row justify-content-between align-items-center">
        <p-button
          label="Annulla"
          type="button"
          styleClass="butt"
          [outlined]="true"
          [rounded]="true"
          (click)="showAddContactForm = false"></p-button>
        <p-button
          type="submit"
          styleClass="butt"
          [rounded]="true"
          label="Aggiungi"></p-button>
      </div>
    </div>
  </form>
</p-dialog>
